import Vue from 'vue';
import PortalVue from 'portal-vue';
import VModal from 'vue-js-modal';
import VueAnalytics from 'vue-analytics';
import '@formatjs/intl-locale/polyfill';
import Vue2Modal from '@arfedulov/vue2-modal';
import VueScrollTo from 'vue-scrollto';
import windowSize from 'universkin-shared/src/plugins/windowSize';
import 'universkin-shared/src/polyfills/setupDisplayNamesPolyfill';

import { i18n } from './i18n';

import App from './App.vue';

import PromisifyVueJsModal from './plugins/PromisifyVueJsModal';
import paypalPlugin from './plugins/paypal';
import wsGrid from './plugins/wsGrid';
import googleMaps from './plugins/googleMaps';
import { $httpApi } from './services/HttpApiService';

import router from './router';
import store from './store';

import './intlNumberFormatPolyfill';

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(VModal);
Vue.use(PromisifyVueJsModal);
Vue.use(paypalPlugin);
Vue.use(Vue2Modal);
Vue.use(VueScrollTo);
Vue.use(wsGrid);
Vue.use(windowSize);
Vue.use(googleMaps);

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router
});

// eslint-disable-next-line vue/require-name-property
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  provide: {
    $httpApi
  }
}).$mount('#app');
